import { useCallback } from 'react';
import { ClipEntityChangedEvent } from '../../../../../server/graphql/__generated.types';
import { useEventsContext } from '../../../../context/events/EventsContext';
import { ClipEventRealtime } from '../../../../services/EventTrackingService';

/*
  This logger exists as a way to track realtime events and leverages mixpanel
*/
export type ClipEntityChangedEventWithCustomEventType = Omit<
  ClipEntityChangedEvent,
  'eventTime' | 'changeType'
> & {
  changeType: ClipEventRealtime;
};
const useRealtimeClipLogger = (projectId: string) => {
  const [eventTracking] = useEventsContext();
  const logger = useCallback(
    (event: ClipEntityChangedEventWithCustomEventType) => {
      const eventType = event?.changeType;
      const clipId = event.clipId || null;
      const clipEntity = event?.clipEntity;
      if (!eventType) {
        // eslint-disable-next-line no-console
        console.error(`EventType not found`);
        return;
      }
      if (!clipId) {
        // eslint-disable-next-line no-console
        console.error(`Clip Not Found for id ${clipId}`);
        return;
      }
      if (!clipEntity) {
        // eslint-disable-next-line no-console
        console.error(`Clip entity not found in ClipEntityChangedEvent`);
        return;
      }
      const { actorId, actorVariantId, text } = clipEntity;
      const { ttsVersion, name: actorName } = clipEntity.actor;
      const actorVariantType = clipEntity.actor.variant.variantType.label;
      eventTracking.trackClipRealtime({
        clipId,
        previousProjectId: event?.previousProjectId || undefined,
        projectId,
        eventType,
        actorId,
        actorVariantId,
        actorVariantType,
        actorName,
        textLength: text.length,
        ttsVersion: ttsVersion || 'N/A',
      });
    },
    [eventTracking, projectId]
  );
  return logger;
};

export default useRealtimeClipLogger;
